import { Badge } from '@evogard/ui';
import type { CatalogStatus } from '@evogard/contract';

/**
 * A situação de um registro, com o que a casa decidiu — ou dizendo que não
 * decidiu.
 *
 * `nao_classificada` sai em tom **neutro** e não de alerta, e a escolha importa:
 * hoje ela é a resposta de toda linha da CE (a tabela nasce vazia), e uma tela
 * inteira em amarelo ensina a ignorar o amarelo. O código cru fica visível
 * porque é com ele que alguém vai à tela de classificação.
 */
export function StatusBadge({ situacao }: { situacao: CatalogStatus }) {
  if (situacao.estado === 'nao_classificada') {
    return (
      <span className="inline-flex items-center gap-1.5">
        <Badge tone="neutro">{situacao.descricao ?? situacao.code}</Badge>
        <span
          className="text-xs text-texto-suave"
          title="a casa ainda não classificou este código"
        >
          não classificada
        </span>
      </span>
    );
  }

  const tone = situacao.deleted ? 'erro' : situacao.canceled ? 'alerta' : 'sucesso';
  return <Badge tone={tone}>{situacao.descricao ?? situacao.code}</Badge>;
}
